module.exports = __webpack_public_path__ + "img/intro.556ca54e.gif";